export default [12, 14, 16, 18, 20, 22, 24, 26, 28, 30, 32, 88];
